export default __webpack_public_path__ + "static/media/upcoming_group.ed7613a8.svg";